import { Injectable, inject } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { interval } from 'rxjs';
import { AppConfig } from 'src/app/app-config';
import { APP_CONFIG } from 'src/app/app-config.token';

@Injectable({ providedIn: 'root' })
export class CheckForUpdateService {
  private config = inject<AppConfig>(APP_CONFIG);



  constructor() {
    // const everyTime$ = interval(config.checkUpdatesEverySeconds * 1000);

    // everyTime$.subscribe(async () => await updates.checkForUpdate());
  }
}